import { AxiosInstance } from "axios";
import { body } from "./validation.type";

export default class Validation {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async addPassword(id: string | undefined, body: body) {
    const url: string = `/validations/${id}`;
    return this.axios.post(url, body);
  }

  //Envio al back el email para comparar dentro de nuestra DB si ya existe
  public async sendResetEmailPassword(body: {username?: string, id?:string}, sendEmail=true) {
    const url: string = `/users/resetPassword?sendEmail=${sendEmail}`
    return this.axios.post(url, body)
  }
}
